import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "../features/modal/modalSlice";
import toastReducer from "../features/toast/toastSlice";

// TODO: combine all slices into a single store at app level
// https://redux.js.org/tutorials/essentials/part-2-app-structure#:~:text=Redux%20Slices%E2%80%8B,multiple%20%22slices%22%20of%20state.
const store = configureStore({
  reducer: {
    modal: modalReducer,
    toast: toastReducer,
  }
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store;